import React, { Component } from 'react';
import { InvoiceHeaderAlt } from './InvoiceHeaderAlt';
import { InvoiceLineItems } from './InvoiceLineItems';
import { InvoiceTotals } from './InvoiceTotals';
import { InvoiceFooter } from './InvoiceFooter';
import { PaymentHistory } from './PaymentHistory';
// Page Footer Component
function PageFooter({
  invoiceNumber,
  pageNumber,
  totalPages
}: {
  invoiceNumber: string;
  pageNumber: number;
  totalPages: number;
}) {
  return <div className="pt-3 mt-auto border-t border-neutral-200 flex justify-between items-center flex-shrink-0" data-id="element-415">
      <p className="text-xs text-neutral-500" data-id="element-416">Invoice No: {invoiceNumber}</p>
      <p className="text-xs text-neutral-500" data-id="element-417">
        Page {pageNumber} of {totalPages}
      </p>
    </div>;
}
export function Invoice3() {
  // Company Information
  const companyInfo = {
    name: 'Pacific Arena Pte Ltd',
    address: ['123 Orchard Road, #12-34', 'Singapore 238858'],
    uen: '202012345A',
    gst: 'AB-12435-CDE',
    travelLicense: 'TA00249',
    logoUrl: 'https://cdn.magicpatterns.com/uploads/cFaHVLHcJR5DqaAKHdTf2Q/image.png'
  };
  // Invoice Information
  const invoiceInfo = {
    number: 'INV-2025-00234',
    issueDate: '15 Jan 2025',
    bookingRef: 'CTB25110001 (PB-HQ)',
    dueDate: '30 Jan 2025',
    salesStaff: 'Sarah Chen',
    bookingStaff: 'Michael Tan',
    productName: 'European Grand Tour Package',
    printedDate: '14:22:26   20 Jan 2025',
    lastUpdateDate: '14:22:26   19 Jan 2025'
  };
  // Bill To Information
  const billToInfo = {
    name: 'Anderson Travel Services Pte Ltd',
    address: ['456 Robinson Road, #08-01', 'Singapore 068903'],
    attn: 'Mr. James Anderson'
  };
  // Page 1 Line Items
  const page1LineItems = [{
    type: 'accommodation' as const,
    category: 'Accommodation',
    itemName: 'Hotel Schweizerhof Zurich',
    details: [{
      label: 'Destination',
      value: 'Zurich, Switzerland'
    }, {
      label: 'Hotel Name',
      value: 'The Dolder Grand'
    }, {
      label: 'Check-In Date',
      value: '01 AUG 2025'
    }, {
      label: 'Check-Out Date',
      value: '04 AUG 2025'
    }, {
      label: 'No. of Nights',
      value: '3'
    }, {
      label: 'Room Type',
      value: 'Double'
    }, {
      label: 'Room Category',
      value: 'Deluxe Suite with Lake View'
    }, {
      label: 'Traveller(s)',
      value: 'LEE / JOO YEOW MR'
    }],
    unitFare: 450.0,
    quantity: 3,
    tax: 135.0,
    discountAmount: 150.0,
    discountRate: 10,
    amount: 1335.0
  }, {
    type: 'flight' as const,
    category: 'Flights',
    itemName: 'Singapore Airlines SIN–ZRH',
    details: [{
      label: 'Routing',
      value: 'SIN / ZRH / SIN'
    }, {
      label: 'Departure Date',
      value: '10 JUN 2025'
    }, {
      label: 'Arrival Date',
      value: '10 JUN 2025'
    }, {
      label: 'Flight No.',
      value: 'GA 825'
    }, {
      label: 'Cabin Class',
      value: 'J (Business)'
    }, {
      label: 'Traveller(s)',
      value: 'HUUSMANS / MARKUS ALEXANDER MR (ADT)'
    }],
    unitFare: 3200.0,
    quantity: 1,
    tax: 320.0,
    discountAmount: 0,
    amount: 3520.0
  }];
  // Page 2 Line Items
  const page2LineItems = [{
    type: 'cruise' as const,
    category: 'Cruises',
    itemName: 'Royal Caribbean Symphony of the Seas',
    details: [{
      label: 'Cruise Line',
      value: 'Royal Caribbean International'
    }, {
      label: 'Voyage Name',
      value: 'Symphony of the Seas - Mediterranean Explorer'
    }, {
      label: 'Emb. Date',
      value: '15 JUN 2025'
    }, {
      label: 'Disemb. Date',
      value: '29 JUN 2025'
    }, {
      label: 'Cabin Type',
      value: 'Balcony Stateroom - Deck 9'
    }, {
      label: 'Traveller(s)',
      value: 'John Mitchell, Sarah Mitchell'
    }],
    unitFare: 4500.0,
    quantity: 2,
    tax: 900.0,
    discountAmount: 500.0,
    discountRate: 5,
    amount: 9400.0
  }];
  // Page 3 Line Items
  const page3LineItems = [{
    type: 'accommodation' as const,
    category: 'Accommodation',
    itemName: 'Ritz-Carlton Paris',
    details: [{
      label: 'Destination',
      value: 'Paris, France'
    }, {
      label: 'Hotel Name',
      value: 'Ritz Paris'
    }, {
      label: 'Check-In Date',
      value: '05 JUL 2025'
    }, {
      label: 'Check-Out Date',
      value: '10 JUL 2025'
    }, {
      label: 'No. of Nights',
      value: '5'
    }, {
      label: 'Room Type',
      value: 'Suite'
    }, {
      label: 'Room Category',
      value: 'Prestige Suite'
    }, {
      label: 'Traveller(s)',
      value: 'ANDERSON / JAMES MR, ANDERSON / EMILY MS'
    }],
    unitFare: 850.0,
    quantity: 5,
    tax: 382.5,
    discountAmount: 0,
    amount: 4632.5
  }];
  // Totals
  const totals = {
    subtotal: 13450.0,
    gstTotal: 1355.0,
    totalDiscount: 650.0,
    total: 14155.0,
    amountReceived: 5000.0,
    balanceDue: 9155.0
  };
  // Payment Instructions
  const paymentInstructions = {
    companyName: 'Pacific Arena Pte Ltd',
    bankName: 'Standard Chartered Bank (Singapore) Limited, Main Branch',
    accountNo: '0-10-492127-7',
    paynowUen: '197600773W',
    notes: ['Transaction fee is non-refundable.', 'Interest of 1% per month will be charged on all overdue balances.']
  };
  // Payment History
  const paymentHistory = [{
    date: '23 Nov 2024',
    type: 'Payment',
    reference: 'RCPT25110078',
    amount: 5000.0,
    currency: 'SGD'
  }];
  return <div className="h-full overflow-auto bg-gradient-to-br from-neutral-50 to-neutral-100 p-6" data-id="element-418">
      <div className="space-y-8" data-id="element-419">
        {/* PAGE 1 - A4 Size: 210mm x 297mm */}
        <div className="w-[210mm] h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col overflow-hidden" data-id="element-420">
          <div className="flex-shrink-0" data-id="element-421">
            <InvoiceHeaderAlt company={companyInfo} invoice={invoiceInfo} billTo={billToInfo} pageNumber={1} totalPages={4} isFirstPage={true} data-id="element-422" />
          </div>
          <div className="flex-1 min-h-0 overflow-hidden" data-id="element-423">
            <InvoiceLineItems items={page1LineItems} data-id="element-424" />
          </div>
          <PageFooter invoiceNumber={invoiceInfo.number} pageNumber={1} totalPages={4} data-id="element-425" />
        </div>

        {/* PAGE 2 - A4 Size: 210mm x 297mm */}
        <div className="w-[210mm] h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col overflow-hidden" data-id="element-426">
          <div className="flex-shrink-0" data-id="element-427">
            <InvoiceHeaderAlt company={companyInfo} invoice={invoiceInfo} billTo={billToInfo} pageNumber={2} totalPages={4} isFirstPage={false} data-id="element-428" />
          </div>
          <div className="flex-1 min-h-0 overflow-hidden" data-id="element-429">
            <InvoiceLineItems items={page2LineItems} data-id="element-430" />
          </div>
          <PageFooter invoiceNumber={invoiceInfo.number} pageNumber={2} totalPages={4} data-id="element-431" />
        </div>

        {/* PAGE 3 - A4 Size: 210mm x 297mm - Final line item with totals and payment */}
        <div className="w-[210mm] h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col overflow-hidden" data-id="element-432">
          <div className="flex-shrink-0" data-id="element-433">
            <InvoiceHeaderAlt company={companyInfo} invoice={invoiceInfo} billTo={billToInfo} pageNumber={3} totalPages={4} isFirstPage={false} data-id="element-434" />
          </div>
          <div className="flex-1 min-h-0 overflow-hidden" data-id="element-435">
            <InvoiceLineItems items={page3LineItems} data-id="element-436" />
            <InvoiceTotals {...totals} data-id="element-437" />
            <InvoiceFooter paymentInstructions={paymentInstructions} data-id="element-438" />
          </div>
          <PageFooter invoiceNumber={invoiceInfo.number} pageNumber={3} totalPages={4} data-id="element-439" />
        </div>

        {/* PAGE 4 - A4 Size: 210mm x 297mm - Payment History */}
        <div className="w-[210mm] h-[297mm] mx-auto bg-white shadow-lg rounded-xl p-8 flex flex-col overflow-hidden" data-id="element-440">
          <div className="flex-shrink-0" data-id="element-441">
            <InvoiceHeaderAlt company={companyInfo} invoice={invoiceInfo} billTo={billToInfo} pageNumber={4} totalPages={4} isFirstPage={false} data-id="element-442" />
          </div>
          <div className="flex-1 min-h-0 overflow-hidden" data-id="element-443">
            <PaymentHistory payments={paymentHistory} data-id="element-444" />
          </div>
          <PageFooter invoiceNumber={invoiceInfo.number} pageNumber={4} totalPages={4} data-id="element-445" />
        </div>
      </div>
    </div>;
}